import React from 'react'
import Carousel from 'nuka-carousel'
import { MagentoMediaGalleryEntry } from 'lib/types'
import { PRODUCT_IMAGE_URL } from 'lib/core/resources/constants'
import { useIsMobile } from 'hooks/responsive'
import { Wrapper, GalleryWrapper, GalleryItem } from './styled'
import { MediaPlaceholder } from './components/MediaPlaceholder'
import { ReactComponent as AngleLeft } from 'resources/svg/icons/chevron-left.svg'
import { ReactComponent as AngleRight } from 'resources/svg/icons/chevron-right.svg'

interface Props {
  productImage: string
  mediaGalleryItems: MagentoMediaGalleryEntry[]
  handleGalleryItem?: (param: MagentoMediaGalleryEntry, index: number) => void
  mediaGalleryIndex: number
  setMediaGalleryIndex: (param: number) => void
  withDots?: boolean
  isConfigurable?: boolean
}

export const MediaGallery = ({ productImage, mediaGalleryItems, handleGalleryItem, mediaGalleryIndex, setMediaGalleryIndex, withDots = false, isConfigurable = false }: Props) => {
  const isMobile = useIsMobile()
  return (
    <Wrapper removeDots={!withDots}>
      {!isMobile && (
        <>
          {mediaGalleryItems.length > 1 && (
            <GalleryWrapper>
              <Carousel
                key='gallery-items'
                wrapAround
                vertical
                transitionMode='scroll'
                slidesToShow={3}
                width='100px'
                slideWidth='95px'
                cellSpacing={15}
                autoGenerateStyleTag={false}
                slideIndex={mediaGalleryIndex}
                slidesToScroll={1}
                renderBottomCenterControls={() => null}
                withoutControls
              >
                {mediaGalleryItems.map((item, index) => (
                  <GalleryItem
                    className={mediaGalleryIndex === index ? 'selected' : ''}
                    onClick={() => handleGalleryItem?.(item, index)}
                    key={item.id}
                  >
                    <img src={`${PRODUCT_IMAGE_URL}${item.file}`} alt={item.content?.name} />
                  </GalleryItem>
                ))}
              </Carousel>
            </GalleryWrapper>
          )}
        </>
      )}
      {mediaGalleryItems.length < 2 ? (
        <MediaPlaceholder imageUrl={productImage} />
      ) : (
        <Carousel
          wrapAround
          transitionMode='scroll'
          slidesToShow={1}
          autoGenerateStyleTag={false}
          slideIndex={mediaGalleryIndex}
          afterSlide={slideIndex => setMediaGalleryIndex(slideIndex)}
          renderCenterLeftControls={({ previousSlide }) => {
            if (withDots) return null

            return (
              <button
                onClick={previousSlide}
                aria-label='Previous'
              >
                <AngleLeft />
              </button>
            )
          }}
          renderCenterRightControls={({ nextSlide }) => {
            if (withDots) return null

            return (
              <button
                onClick={nextSlide}
                aria-label='Next'
              >
                <AngleRight />
              </button>
            )
          }}
        >
          {mediaGalleryItems.map((item, index) => {
            const mainImage = `${PRODUCT_IMAGE_URL}${item.file}`
            return (
              <div key={index}>
                <MediaPlaceholder imageUrl={isConfigurable ? productImage : mainImage} />
              </div>
            )
          })}
        </Carousel>
      )}
    </Wrapper>
  )
}
